<template>
  <a-layout-content>
    <a-row>
      <a-col :xs="24" :sm="12">
        <a-card title="赛事开关">
          <a-button type="primary" size="large" @click="contest(1)" v-if="!system.control">开启赛事</a-button>
          <a-button type="primary" size="large" @click="contest(0)" v-else>关闭赛事</a-button>
          <h4>修改轮数：</h4>
          <a-input-number v-model="lun" />
          <a-button type="primary" size="large" @click="setlun()">修改</a-button>
          <h4>结算轮数：</h4>
          <a-input-number v-model="jslun" />
          <a-button type="primary" size="large" @click="jisuan()">结算</a-button>
          </a-card>
      </a-col>
    </a-row>
    <a-row>
      <a-col>
        <a-card title="竞拍记录">
          <a-table :columns="columns" :dataSource="list">
          </a-table>
        </a-card>
      </a-col>
    </a-row>
  </a-layout-content>
</template>
<script>
const columns = [{
  title: '竞拍用户',
  dataIndex: 'user',
  key: 'user'
}, {
  title: '详细信息',
  dataIndex: 'record',
  key: 'record'
}, {
  title: '时间',
  dataIndex: 'time',
  key: 'time'
}
]
export default {
  data () {
    return {
      user: [],
      system: [],
      columns,
      list: [],
      lun: 0,
      jslun: 0
    }
  },
  created () {
    this.$http.get('https://auction-api.joyland.top/system').then(res => {
      this.system = res.data
      this.lun = res.data.lun
    })
    this.$http.get('https://auction-api.joyland.top/getlist').then(res => {
      this.list = res.data
    })
  },
  methods: {
    push (name) {
      this.$router.push('/' + name)
    },
    contest (control) {
      this.$http
        .get('https://auction-api.joyland.top/contest?control=' + control + '&cid=' + this.system.id)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.info('修改成功')
          } else if (res.data.code === 1002) {
            this.$message.warning(res.data.err)
          }
        })
    },
    setlun () {
      console.log(this.lun)
      this.$http
        .get('https://auction-api.joyland.top/setlun?lun=' + this.lun + '&cid=' + this.system.id)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.info('修改成功')
          } else if (res.data.code === 1002) {
            this.$message.warning(res.data.err)
          }
        })
    },
    jisuan () {
      this.$http
        .get('https://auction-api.joyland.top/jiesuan?lun=' + this.jslun + '&cid=' + this.system.id)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.info('结算成功')
          } else if (res.data.code === 1002) {
            this.$message.warning(res.data.err)
          }
        })
    }
  }
}
</script>
